import { Fragment, useContext } from "react";
import { AuthContext } from "../../store/auth-context";
//* import global component
import Button from "../UI/Button";
//* import styles
import styles from "./SignUpForm.module.css";
const SignUpFormAction1 = (props) => {
  const { onDispatchForm } = props;
  //*context
  const authCtx = useContext(AuthContext);
  const clickLoginHandler = async () => {
    await onDispatchForm({ type: "RESET" });
    authCtx.onSignUp(false);
  };

  return (
    <Fragment>
      {authCtx.registerReplyStates.isLoading && (
        <p>Loading...</p>
      )}
      {!authCtx.registerReplyStates.isLoading && (
        <p
          className={`${"error"} ${
            authCtx.registerReplyStates.error
          }`}
        >
          {authCtx.registerReplyStates.reply}
        </p>
      )}

      <div className={styles["form-actions"]}>
        <Button
          className={`${styles["register-button"]}`}
          type="submit"
        >
          Register
        </Button>
      </div>
      <Button
        type="button"
        className={styles.login}
        onClick={clickLoginHandler}
      >
        Already have an account?
        <span> Login</span>
      </Button>
    </Fragment>
  );
};

export default SignUpFormAction1;
